/**
 * The tenant-blocked marker cookie, `veltric_tenant_blocked=1`.
 *
 * Written by the cockpit itself (PB-TBB-1): the ApiClient's 403 branch calls
 * {@link tenantBlockedStore.setBlocked} on `errorCode=tenantBlocked`, so the
 * next page load renders the block banner without a round trip. The backend
 * answers that 403 with a JSON body only — it never set the cookie, which is
 * why the banner could not appear before. The marker is cleared locally when
 * the block lifts (the provider re-checks the company at mount) and on logout.
 *
 * This is the only place in the cockpit that should touch
 * `veltric_tenant_blocked`. UI preferences belong in `lib/storage/userPrefs`.
 */
export const tenantBlockedStore = {
  isBlocked(): boolean {
    if (typeof document === "undefined") return false;
    return document.cookie
      .split("; ")
      .some((c) => c === "veltric_tenant_blocked=1");
  },
  setBlocked(): void {
    if (typeof document === "undefined") return;
    // Session cookie, whole origin — the marker is read by both shells
    // (`/user/*` and `/event/*`) and must not outlive the browser session on
    // its own: the mount re-check and logout are what end it.
    document.cookie = "veltric_tenant_blocked=1; path=/";
  },
  clear(): void {
    if (typeof document === "undefined") return;
    document.cookie = "veltric_tenant_blocked=; path=/; max-age=0";
  },
};
